import { phoneMask } from "../utils/masks";

const phoneInput = document.getElementById("formatted");
phoneMask(phoneInput);
